module.exports = __webpack_public_path__ + "static/media/my-number-card-front-sample.d2397135.svg";